import React, { useState } from 'react';
import { Copy, MessageSquare, ArrowLeft } from 'lucide-react';

const VoiceResult = ({ text, label, onInjectToChat, onBack }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      <button onClick={onBack} style={styles.backBtn}>
        <ArrowLeft size={14} /> Retour
      </button>
      <div style={styles.label}>{label}</div>
      <div style={styles.textBox}>{text}</div>
      <div style={styles.actions}>
        <button onClick={handleCopy} style={styles.btn}>
          <Copy size={14} /> {copied ? 'Copie !' : 'Copier'}
        </button>
        <button onClick={() => onInjectToChat(text)} style={styles.btnPrimary}>
          <MessageSquare size={14} /> Envoyer au Chat
        </button>
      </div>
    </div>
  );
};

const styles = {
  backBtn: {
    background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer',
    display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, marginBottom: 12, padding: 0,
  },
  label: {
    fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1,
    color: '#f97316', marginBottom: 8,
  },
  textBox: {
    background: '#0f172a', borderRadius: 8, padding: 14, fontSize: 13, lineHeight: 1.6,
    color: '#e2e8f0', maxHeight: 280, overflowY: 'auto', marginBottom: 12,
    border: '1px solid #334155', whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex', gap: 8,
  },
  btn: {
    flex: 1, padding: '10px 0', borderRadius: 8, border: '1px solid #475569',
    background: '#334155', color: '#e2e8f0', cursor: 'pointer', fontSize: 13,
    fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
  },
  btnPrimary: {
    flex: 1, padding: '10px 0', borderRadius: 8, border: 'none',
    background: '#f97316', color: 'white', cursor: 'pointer', fontSize: 13,
    fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
  },
};

export default VoiceResult;
